import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconAttachmentSvg } from "./IconAttachmentSvg.mjs";
const IconAttachment = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconAttachmentSvg, ...svgProps }) });
export {
  IconAttachment
};
